module.exports = function() {
  return new Worker(__webpack_public_path__ + "c681c441fc8856192844.worker.js");
};